import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-laudo-lme-list",
  templateUrl: "./laudo-lme-list.component.html",
  styleUrls: ["./laudo-lme-list.component.css"],
})
export class LaudoLmeListComponent implements OnInit {
  listaDeLaudosLme: any[] = [];
  @Input() exibeFormulario: boolean = false;
  formulario: any = {
    cidadao: null,
    dataSolicitacao: null,
  };

  constructor(
    private global: Global,
    public service: ApiService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {    
    this.buscarLaudosLme();
  }

  buscarLaudosLme() {
    this.service
      .Get(
        `LaudoLme?atendimento_id=${this.route.snapshot.paramMap.get("uuid")}`
      )
      .then((res: any) => {
        this.listaDeLaudosLme = res;
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        Swal.fire("Erro", `${res.message}`, "error");
      });
  }

  imprimirDado(id: any) {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .PostImpresso(`Documento/impresso-pdf/LME.frx`, [
        {
          nome: "id",
          valor: id.toString(),
        },
      ])
      .then((res) => {
        if (res) {
          var link: any = res;
          Swal.close();
          window.open(link, "_blank");
        }
      })
      .catch((err) => {        
        Swal.fire({
          title: "Erro!",
          text: err.error.messagem || "Ocorreu um erro.",
          icon: "error",
        });
      });
  }

  enviarWhatsApp(item: any) {
        Swal.fire("Favor aguarde");
        Swal.showLoading();
        var tipoImpresso: Number = 11;
    
        this.service.Get(`Documento/impresso/Whatsapp/${item.id}?atendimento_id=${item.atendimento_id}&tipo_documento=${tipoImpresso}`)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Sucesso",
              text: "Declaração enviada com sucesso!",
            }).then(() => {
              Swal.close();
            });
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Erro",
              text: "Erro ao enviar a declaração!",
            }).then(() => {
              Swal.close();
            });
          });
      }
}
